export interface PhonemeData {
  sounds: string[];
}

export interface PhonemeGroupData {
  name: string;
  color: string;
  phonemes: PhonemeData[];
}

export const PhonemeGroups: {
  [key: string]: { groups: string[]; minMaxSize: number[]; standardSize: number };
} = {
  "Single Sounds": { groups: ["single"], minMaxSize: [0.6, 0.35], standardSize: 0.4 },
  "Consonant Digraphs": {
    groups: ["consonant", "otherconsonant"],
    minMaxSize: [0.7, 0.34],
    standardSize: 0.21,
  },
  "Long Vowel Phonemes": {
    groups: ["commonlongvowels", "otherlongvowels"],
    minMaxSize: [0.8, 0.42],
    standardSize: 0.32,
  },
};

export const Phonemes: { [key: string]: PhonemeGroupData } = {
  single: {
    name: "Single Sounds",
    color: "#FFB4A0",
    phonemes: [
      { sounds: ["a"] },
      { sounds: ["b"] },
      { sounds: ["c"] },
      { sounds: ["d"] },
      { sounds: ["e"] },
      { sounds: ["f"] },
      { sounds: ["g"] },
      { sounds: ["h"] },
      { sounds: ["i"] },
      { sounds: ["j"] },
      { sounds: ["k"] },
      { sounds: ["l"] },
      { sounds: ["m"] },
      { sounds: ["n"] },
      { sounds: ["o"] },
      { sounds: ["p"] },
      { sounds: ["q"] },
      { sounds: ["r"] },
      { sounds: ["s"] },
      { sounds: ["t"] },
      { sounds: ["u"] },
      { sounds: ["v"] },
      { sounds: ["w"] },
      { sounds: ["x"] },
      { sounds: ["y"] },
      { sounds: ["z"] },
    ],
  },
  consonant: {
    name: "Consonant Digraphs",
    color: "#7FDFDB",
    phonemes: [
      { sounds: ["ch"] },
      { sounds: ["sh"] },
      { sounds: ["wh"] },
      { sounds: ["th"] },
      { sounds: ["ph"] },
      { sounds: ["ng"] },
      { sounds: ["ck"] },
      { sounds: ["ss"] },
      { sounds: ["ff"] },
      { sounds: ["zz"] },
      { sounds: ["ll"] },
      { sounds: ["qu"] },
    ],
  },
  commonlongvowels: {
    name: "Common Long Vowel Phonemes",
    color: "#FEE9A5",
    phonemes: [
      { sounds: ["a", "e"] },
      { sounds: ["ay"] },
      { sounds: ["ai"] },
      { sounds: ["ea"] },
      { sounds: ["ee"] },
      { sounds: ["y"] },
      { sounds: ["ey"] },
      { sounds: ["ie"] },
      { sounds: ["igh"] },
      { sounds: ["i", "e"] },
      { sounds: ["oa"] },
      { sounds: ["ow"] },
      { sounds: ["o", "e"] },
      { sounds: ["oo"] },
      { sounds: ["ew"] },
      { sounds: ["ue"] },
      { sounds: ["u", "e"] },
      { sounds: ["oul"] },
      { sounds: ["ou"] },
      { sounds: ["ow"] },
    ],
  },
  otherlongvowels: {
    name: "Other Long Vowel Phonemes",
    color: "#FEE9A5",
    phonemes: [
      { sounds: ["ar"] },
      { sounds: ["er"] },
      { sounds: ["ir"] },
      { sounds: ["ur"] },
      { sounds: ["or"] },
      { sounds: ["oi"] },
      { sounds: ["oy"] },
      { sounds: ["air"] },
      { sounds: ["ere"] },
      { sounds: ["are"] },
      { sounds: ["eir"] },
      { sounds: ["ear"] },
      { sounds: ["ai"] },
      { sounds: ["au"] },
      { sounds: ["aw"] },
      { sounds: ["ore"] },
      { sounds: ["our"] },
      { sounds: ["ure"] },
      { sounds: ["augh"] },
      { sounds: ["ough"] },
      { sounds: ["aur"] },
      { sounds: ["aigh"] },
      { sounds: ["eigh"] },
      { sounds: ["uy"] },
      { sounds: ["ui"] },
    ],
  },
  otherconsonant: {
    name: "Other Consonant Digraphs",
    color: "#7FDFDB",
    phonemes: [
      { sounds: ["bb"] },
      { sounds: ["dd"] },
      { sounds: ["mm"] },
      { sounds: ["nn"] },
      { sounds: ["pp"] },
      { sounds: ["rr"] },
      { sounds: ["ss"] },
      { sounds: ["tt"] },
      { sounds: ["kn"] },
      { sounds: ["le"] },
      { sounds: ["me"] },
      { sounds: ["ne"] },
      { sounds: ["ve"] },
      { sounds: ["tch"] },
      { sounds: ["dge"] },
      { sounds: ["ge"] },
      { sounds: ["ed"] },
      { sounds: ["se"] },
      { sounds: ["ce"] },
      { sounds: ["gh"] },
      { sounds: ["sc"] },
      { sounds: ["ti"] },
      { sounds: ["si"] },
      { sounds: ["ci"] },
      { sounds: ["ugh"] },
      { sounds: ["xe"] },
    ],
  },
};
